import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';
import type { Dateable } from 'pkg/api/models/dateable';
import type { ProductCategory } from 'pkg/api/models/product_category';
import type { ProductPrice } from 'pkg/api/models/product_price';
import type { Record } from 'pkg/api/models/record';

export enum ProductType {
	Standard = 'standard',
	MembershipCard = 'membership_card',
}

export interface ProductMetadata extends Record {
	key: string;
	value: string;
	productId: number;

	product?: Product;
}

export interface Product extends Record, Dateable, AllowedActionable {
	accountId: number;
	archivedAt: number;
	description: string;
	groupId: number;
	isDefault: boolean;
	name: string;
	paymentProviderId: string;
	productCategoryId: number;
	type: ProductType;
	metadata: ProductMetadata[];
	prices: ProductPrice[];
	category: ProductCategory;
}

export interface ProductCreatePayload {
	name: string;
	groupId: number;
	isDefault: boolean;

	metadata?: { key: string; value: string }[];
	description?: string;
	productCategoryId?: number;
	type?: ProductType;
}

export interface ProductUpdatePayload {
	name: string;
	groupId: number;
	isDefault: boolean;

	metadata?: { key: string; value: string }[];
	description?: string;
	productCategoryId?: number;
	type?: ProductType;
}
